<template>

    <div class="OOP-today OOP-carousel__results" v-if="matches.length > 0">

        <carousel
            :flag       = "flagPath"
            :assoc      = "type"
            :detail     = "detail"
            :matches    = "matches"
            :class_name = "class_name"
            mode        = "result">
        </carousel>

        <div class="go-more">
            <a :href="results">View All Results</a>
        </div>

    </div>

</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import Carousel from './MatchesCarousel'

    export default {
        components: {
            'carousel' : Carousel,
        },
        props: [ 'type', 'flag', 'detail', 'results', 'tournament' ],
        data() {
            return {
                feed            : [],
                matches         : [],
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                tournament_slug : this.tournament,
                class_name      : 'OOP-carousel__results',
            }
        },
        created() {
            axios.get(`${window.feed_ip}/get/${this.type}/${this.tournament_slug}/draws`).then(response => {

                this.feed = response.data

                let allMatches = this.getAllMatchesInOneArray(response.data)
                let finishedMatches = this.getOnlyFinishedMatches(allMatches)

                let app = this

                //sort descending
                finishedMatches.sort( function(a, b) {

                    let dateFormat;
                        dateFormat = 'YYYY-MM-DDTHH'

                    let matchDateA = moment( a.detail.ts, dateFormat ).format()
                    let matchDateB = moment( b.detail.ts, dateFormat ).format()

                    if ( moment( matchDateA ).isAfter( matchDateB ) )
                        return -1
                    else if ( moment( matchDateA ).isBefore( matchDateB ) )
                        return 1
                    else if ( moment( matchDateA ).isSame( matchDateB ) )
                        return 0

                })

                //show only the last 4 matches
                finishedMatches.splice(8)

                this.matches = finishedMatches

            }).catch(function (error) {
                console.log(error);
            });
        },
        methods: {
            getOnlyFinishedMatches(matches) {
                return matches.filter(function(match) {

                    return match.detail.state == 'F'

                })

            },
            getAllMatchesInOneArray(feed) {
                let allMatches = []

                for (let event of feed) {
                    for (let round of event.rounds) {
                        allMatches.push(...round.matches)
                    }
                }

                return allMatches
            },
        }

    }
</script>
